// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluationPage-cls1_W-c","cls2":"EvaluationPage-cls2_Cfu EvaluationPage-cls1_W-c"};